import React, { useState } from "react";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import { documentTypeIdsToNames } from "FileCabinetContextWrapper";

interface IProps {
  onFocus: () => void;
  onChange?: (documentTypeId: number) => void;
  includeOnlyOptions?: number[];
  initialDocumentTypeId: number;
}

export function DocumentTypeFormControl(props: IProps): JSX.Element {
  const [documentType, setDocumentType] = useState<number>(props.initialDocumentTypeId);

  const getOptions = (): JSX.Element[] => {
    const elements: JSX.Element[] = [];
    documentTypeIdsToNames.map((name: string, index: number) => {
      if (index > 0) {
        if (
          !props.includeOnlyOptions ||
          props.includeOnlyOptions.find((i) => i === index)
        ) {
          elements.push(
            <MenuItem key={"m" + index.toString()} value={index}>
              {name}
            </MenuItem>
          );
        }
      }
    });

    return elements;
  };

  return (
    <FormControl fullWidth key={"newfiledoctypeformcontrol"}>
      <InputLabel id="documentTypeLabel">Document Type</InputLabel>
      <Select
        label={"Document Type"}
        labelId={"documentTypeLabel"}
        value={documentType}
        onFocus={props.onFocus}
        onChange={(event: any) => {
          setDocumentType(event.target.value);
          if(props.onChange) {
            props.onChange(event.target.value);
          }
          
        }}
        style={{ width: "100%", display: "flex", marginBottom: "1rem" }}
      >
        {getOptions()}
      </Select>
    </FormControl>
  );
}
